import { createContext } from "react";
import { DefaultContext } from "../../../constants/context/context";

export const LoginContext = createContext(DefaultContext);
